module.exports = __webpack_public_path__ + "img/ic_notification_probetraining.b3dcc807.svg";